<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 lg6 offset-lg3>
        <v-alert
          v-model="isError"
          dismissible
          type="error"
          transition="fade-transition"
        >
          {{ errMessage }}
        </v-alert>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 lg6 offset-lg3>
        <h1>Confirm Email Address</h1>
        <p>Please check your email for a confirmation token value and paste it here</p>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4>
        <v-form @submit="submit">
          <v-text-field
            v-model="token"
            label="Confirmation Token"
            required
            id="token"
          />
          <v-btn
            block
            type="submit"
            id="submit"
          >
          Confirm Account
          </v-btn>
          <v-btn
            block
            id="resend"
            :disabled="!canResend"
            @click="resend"
          >
          {{ resendText }}
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    token: '',
    canResend: true,
    resendText: 'Re-Send Email',
    isError: false,
    errMessage: null
  }),
  methods: {
    submit (ev) {
      ev.preventDefault()

      // Try to confirm our account
      this.axios.post('/auth/confirmation', {
        token: this.token
      })
        .then(() => {
          // If we successfully confirmed, update our user's profile to reflect
          // this fact, then redirect them back to the app
          this.$auth.fetch({ success: () => {
            return this.$router.push('/')
          } })
        })
        .catch(this.$root.apiErrorHandler((msg, errors) => {
          this.errMessage = errors['token'] || msg
          this.isError = true
        }))
    },
    resend () {
      this.axios.get('/auth/confirmation')
        .then(() => {
          // If we successfully re-sent the email, disable the button so the user
          // can't just keep sending emails, but let them know that it's been sent
          this.canResend = false
          this.resendText = 'Email Re-Sent'
        })
        .catch(this.$root.apiErrorHandler((msg) => {
          this.errMessage = msg
          this.isError = true
        }))
    }
  },
  mounted: function () {
    // If we have a confirmation token in the URL, pre-populate it
    if (this.$route.params.token) {
      this.token = this.$route.params.token
    }
  }
}
</script>
